/*
 * Dependencies:
 * - MediaElementPlayer (http://www.mediaelementjs.com/)
 */

define('components/videofactory/views/HTMLVideoView', [
    'components/videofactory/templates/htmlvideoview'
], function(tpl) {

    var HTMLVideoView = Mazarine.View.extend({

        events: {},

        template: tpl,

        className: "maz-html-video-view",

        player: null,
        $player: null,
        jsPlayer: null,

        afterRender: function() {
            var self = this;
            this.$player = this.$('video');
            this.player = this.$player.get(0);

            this.jsPlayer = new MediaElementPlayer( this.$player, {
                "videoWidth": this.model.get('videoWidth'),
                "videoHeight": this.model.get('videoHeight'),
                "pluginPath": this.model.get('pluginPath'),
                "features": [],
                success: function (mediaElement, domObject) {
                    // Events for Flash player
                    mediaElement.addEventListener('play', function(e) { self.onPlay(); }, false);
                    mediaElement.addEventListener('pause', function(e) { self.onPause(); }, false);
                    mediaElement.addEventListener('ended', function(e) { self.onEnded(); }, false);
                    mediaElement.addEventListener('loadedmetadata', function(e) { self.onReady(); }, false);
                }
            });

            // Events for HTML5 player
            this.$player.on('play', _.bind(this.onPlay, this));
            this.$player.on('pause', _.bind(this.onPause, this));
            this.$player.on('ended', _.bind(this.onEnded, this));
            this.$player.on('loadedmetadata', _.bind(this.onReady, this));
        },

        destroy: function() {
            // TODO ???
            // this.jsPlayer.dispose();
        },

        play: function() {
            var self = this;

            self.jsPlayer.play();

            // FIXME: hack to make play/autoplay work on slow IE8s, player needs to be able to play before play is called
            setTimeout(function() {
                self.jsPlayer.play();
            }, 1000);
        },

        pause: function() {
            this.jsPlayer.pause();
        },

        stop: function() {
            this.jsPlayer.setCurrentTime(0);
            this.jsPlayer.pause();
        },

        toggleFullScreen: function() {
            // TODO ? I thing jsPLayer handle this
            // if (this.player.requestFullscreen) {
            //     this.player.requestFullscreen();
            // } else if (this.player.mozRequestFullScreen) {
            //     this.player.mozRequestFullScreen();
            // } else if (this.player.webkitRequestFullscreen) {
            //     this.player.webkitRequestFullscreen();
            // }
        },

        setCurrentTime: function(seconds) {
            this.jsPlayer.setCurrentTime( seconds );
        },

        getCurrentTime: function() {
            return this.jsPlayer.getCurrentTime() * 1000;
        },

        getDuration: function() {
            return this.jsPlayer && this.jsPlayer.getDuration() * 1000;
        },

        mute: function() {
            this.jsPlayer.setMuted( true );
        },

        unMute: function() {
            this.jsPlayer.setMuted( false );
        },

        onProgress: function() {
            this.model.set('currentTime', this.jsPlayer.getCurrentTime() * 1000 );
        },

        onReady: function() {
            // this.jsPlayer.setPlayerSize( this.model.get('videoWidth'), this.model.get('videoWidth') );
            this.$('.maz-html-player').width( this.model.get('videoWidth') );
            this.$('.maz-html-player').height( this.model.get('videoHeight') );
            this.model.set('duration', this.getDuration() );
            var onReadyCallback = this.model.get('onReady');

            if ( _.isFunction(onReadyCallback)) {
                onReadyCallback();
            }
        },

        onPlay: function() {
            this.playInterval = setInterval(_.bind( this.onProgress, this), 200);

            var callback = this.model.get('onPlay');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onPause: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onPause');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onEnded: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onEnded');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onFullscreenChange: function(e) {
            // var callback = this.model.get('onFullscreenChange');
            // if (_.isFunction(callback)) {
            //     callback(e, this.player.isFullScreen);
            // }
        }
    });

    return HTMLVideoView;
});
